import { render, staticRenderFns } from "./FeedTags_Button.vue?vue&type=template&id=7cd533aa&scoped=true&"
import script from "./FeedTags_Button.vue?vue&type=script&lang=js&"
export * from "./FeedTags_Button.vue?vue&type=script&lang=js&"
import style0 from "./FeedTags_Button.vue?vue&type=style&index=0&id=7cd533aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd533aa",
  null
  
)

export default component.exports